<template>
  <div>
    <div class="row">
      <div class="col-3">
        <txt label="Name" name="dependent_name" v-model="model.name" />
      </div>
      <div class="col-3">
        <txt label="Age" name="age" v-model="model.age" />
      </div>
      <div class="col-3">
        <txt
          label="Relationship"
          name="relation"
          v-model="model.relationship"
        />
      </div>
      <div class="col-3">
        <tl-select
          label="Marital Status"
          :options="['Unmarried', 'Married']"
          v-model="model.maritalstatus"
          @change="(val) => (model.maritalstatus = val)"
        ></tl-select>
      </div>
    </div>
    <footer>
      <popup-bottom-container>
        <template slot="end">
          <btn-grp class="form-button">
            <btn text="Back" type="secondary" @click="goBack" />
            <btn text="Save" type="primary" @click="saveDependent" />
          </btn-grp>
        </template>
      </popup-bottom-container>
    </footer>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { eventBus } from "@/main";

export default {
  name: "addDependentsPopup",
  data() {
    return {
      model: {
        name: "",
        age: "",
        relationship: "",
        maritalstatus: "",
        employee_id: "",
        it_plan_id: "",
      },
    };
  },
  activated() {},
  mounted() {
    // eventBus.$on("editDependent", dependentData => {
    //   //console.log("Its data", dependentData);
    // })
    this.editDependent();
  },
  created() {
    eventBus.$on("editDependent", this.editDependent);
  },
  computed: {
    ...mapGetters({
      getleid: "onboard/legal_entities/legal_entity_ID",
    }),

    le_id() {
      if (this.$route.params.entity_index)
        return this.getleid(this.$route.params.entity_index);
      else return this.getleid(0);
    },
  },
  methods: {
    ...mapActions({
      act_fetch: "onboard/employees/fetchAll",
      fetchLocations: "onboard/locations/fetchAll",
      act_get_dependents: "dashboard/payroll/incometax/getDependentList",
      act_get_active_it_plan: "dashboard/payroll/incometax/getActiveList",
      act_create: "dashboard/payroll/incometax/createDependents",
      act_update: "dashboard/payroll/incometax/update",
    }),

    async saveDependent() {
      let empId = this.$route.query.id;
      this.model.employee_id = empId;
      let data = await this.act_get_active_it_plan(empId);
      this.model.it_plan_id = data.data.payload.id;
      let res = await this.act_create(this.model);
      //console.log("Model", this.model);
      this.$emit("saveDependent");
    },

    // Add here code for cancel button to hide popup By Bhushan
    goBack() {
      this.$emit("saveDependent");
    },

    async editDependent(dependentData) {
      //console.log("Dependent data", dependentData.id);
      let obj = {
        id: dependentData.id,
        name: this.model.name,
        age: this.model.age,
        relationship: this.model.relationship,
        maritalstatus: this.model.maritalstatus,
        employee_id: dependentData.employee_id,
        it_plan_id: dependentData.it_plan_id,
      };
      let res = await this.act_update(obj);
      //console.log("Approval data OBJ", obj);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/scss/components/margins.scss"; //margins
@import "@/scss/_variables.scss";
</style>
